var exports = {
  "nf": "xe30f6088--409ca4--link",
  "f": "xe30f6088--409ca4--accent",
  "zB": "xe30f6088--409ca4--primary",
  "BB": "xe30f6088--409ca4--light",
  "dW": "xe30f6088--409ca4--underlined",
};

module.exports = exports;
